import { IPromocodeItem } from "../../../../Bonus/types/bonusesActions";
import { useCallback, useEffect, useMemo, useState } from "react";
import moment from "moment";
import _ from "lodash";
import { useTimer } from "../../../../../hooks/useTimer";
import { useLangContext } from "../../../../../providers/LangProvider/LangProviderContext";

const useDepositPromocodesEnd = (item: IPromocodeItem) => {
    const { getLangPath } = useLangContext();
    const [secondsLeft, setSecondsLeft] = useState<number | null>(null);

    const endAt = useMemo(() => {
        if (!item) return null;
        const promocodeEndAt = item.end_at;
        const parsedHoursToUse = parseFloat(item.hours_to_use);
        const accountPromocodeEndAt = parsedHoursToUse
            ? moment(item.created_at).add(item.hours_to_use, 'hours').toISOString()
            : null;
        return _.min([promocodeEndAt, accountPromocodeEndAt]) || null;
    }, [item]);

    const handleUpdateSecondsLeft = useCallback(() => {
        const now = moment();
        const endAtMoment = moment(endAt);
        setSecondsLeft(endAtMoment.diff(now, 'seconds'));
    }, [endAt]);

    const timerLabel = useMemo(() => {
        if (secondsLeft === null) {
            return ''
        }

        if (secondsLeft < 24 * 60 * 60) {
            const duration = moment.duration(secondsLeft, 'seconds');
            return moment.utc(duration.asMilliseconds()).format('HH[h] mm[m] ss[s]');
        } else {
            const endAtMoment = moment(endAt);
            return getLangPath('promocodes.until_end_at', { end_at: endAtMoment.format('Do MMMM') })
        }
    }, [endAt, getLangPath, secondsLeft]);

    const { isTimerRunning, startTimer, stopTimer } = useTimer(handleUpdateSecondsLeft);

    useEffect(() => {
        const isNeedTimer = endAt && moment(endAt) > moment();
        if (isNeedTimer && !isTimerRunning) {
            startTimer(1000);
        }
        if (!isNeedTimer && isTimerRunning) {
            stopTimer();
        }
    }, [endAt, isTimerRunning, startTimer, stopTimer]);

    return { endAt, secondsLeft, timerLabel };
}

export default useDepositPromocodesEnd;
